export default __webpack_public_path__ + "static/media/risk-level-1.138bf11f.svg";